import { onApiError } from "../error";
import type { Smartplug2 } from "../smartplug2/sp2";
import { get, put } from "./client";

export const getSp2 = async (imei: string): Promise<Smartplug2> => {
	const res = await get(`/smartplug2s/${imei}`);
	if (!res.ok) throw await onApiError(res);
	const sp2 = await res.json();
	return sp2;
};

export const putSp2 = async (sp2: Smartplug2): Promise<Smartplug2> => {
	const res = await put(`/smartplug2s/${sp2.Imei}`, {
		body: JSON.stringify(sp2),
	});

	if (!res.ok) throw await onApiError(res);

	sp2 = await res.json();
	return sp2;
};
